var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "auth", style: { minHeight: _vm.height } },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", [
          _c("p", [
            _c(
              "a",
              { staticClass: "jzq-com", attrs: { href: _vm.junziqanIndex } },
              [_vm._v("返回首页")]
            )
          ])
        ])
      ]),
      _c(
        "el-card",
        { staticClass: "card", attrs: { "body-style": _vm.bodyStyle } },
        [
          _c(
            "div",
            { staticClass: "guide" },
            [
              _c("img", {
                staticClass: "authLogo",
                attrs: { src: "/images/auth/authLogo.png" }
              }),
              _c("div", { staticClass: "text" }, [
                _c("p", { staticClass: "title" }, [
                  _vm._v("\n          企业实名认证\n        ")
                ]),
                _c("p", { staticClass: "content" }, [
                  _vm._v(
                    "\n          《中华人民共和国电子签名法》要求签署方身"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n          份真实，请根据您的身份选择以下操作方式\n        "
                  )
                ])
              ]),
              _c(
                "div",
                { staticStyle: { "text-align": "center" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { checked: true },
                      model: {
                        value: _vm.checked,
                        callback: function($$v) {
                          _vm.checked = $$v
                        },
                        expression: "checked"
                      }
                    },
                    [
                      _c("span", { staticStyle: { color: "#666666" } }, [
                        _vm._v("我已阅读并同意")
                      ]),
                      _c(
                        "a",
                        {
                          staticClass: "showAgreement",
                          staticStyle: { color: "#409EFF" },
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function($event) {
                              _vm.showProtocol = true
                            }
                          }
                        },
                        [_vm._v("《实名认证服务协议》")]
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "btn-wrapper" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { type: "danger", disabled: !_vm.checked },
                      on: {
                        click: function($event) {
                          return _vm.showAuth()
                        }
                      }
                    },
                    [_vm._v("\n          法定代表人操作\n        ")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn plain",
                      attrs: { plain: "", disabled: !_vm.checked },
                      on: {
                        click: function($event) {
                          return _vm.showAuth(4)
                        }
                      }
                    },
                    [_vm._v("\n          不是法定代表人操作\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("real-name-protocol", {
        attrs: { visible: _vm.showProtocol, type: "register" },
        on: {
          "update:visible": function($event) {
            _vm.showProtocol = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10d6d77e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10d6d77e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/auth/authGuide_copy.vue
// module id = G6IL
// module chunks = 179